import { aplicarValorSelectAFiltros } from "../../helper/opcionesFiltros";

class SetFiltros {
  constructor(componente,actuarOnChange, setFiltrosAAplicar, setError, cab) {
    this.componente = componente;
    this.setFiltrosAAplicar = setFiltrosAAplicar;
    this.setError = setError;
    this.cab = cab;
    this.actuarOnChange = actuarOnChange;

    // Mapeo de funciones según tipo de componente
    this.handlers = {
      autocompletar: this.handleAutocompletar,
      autocompletar_fetch: this.handleBase,
      checkbox: this.handleCheckbox,
      enum: this.handleSelect,
      fecha: this.handleDatePicker,
      fecha_simple: this.handleDatePickerFechaSimple,
      filtro_buscador: this.handleInputText,
      like: this.handleInputText,
      number: this.handleInputText,
      radio: this.handleRadio,
      select: this.handleSelect,
    };
  }

  aplicar(valor, aux) {
    const handler = this.handlers[this.componente];

    if (!handler) {
      this.setError(`No existe handler para el componente: ${this.componente}`);
      return;
    }
    handler.call(this, valor, aux);
  }

  // ---------- Handlers internos ----------

  handleInputText(valor) {
    this.setFiltrosAAplicar((prevState) => {
      const nuevosFiltros = { ...prevState, [this.cab.id_a]: valor };

      if (this.cab.clave_envio) {
        nuevosFiltros[this.cab.clave_envio] = valor;
      }

      return nuevosFiltros;
    });

    this.setError((e) => {
      return { ...e, [this.cab.id_a]: false };
    });
  }

  handleAutocompletar(opcionElegida) {
    this.setFiltrosAAplicar((prevState) => {
      const clave = this.cab.clave_envio;
      const nuevoValor = opcionElegida === null ? "" : opcionElegida.value;

      const newState = { ...prevState, [this.cab.id_a]: nuevoValor };
      if (clave) {
        newState[clave] = nuevoValor;
      }

      return newState;
    });
  }

  handleBase(valor) {
    this.setFiltrosAAplicar((prevState) => {
      const nuevosFiltros = { ...prevState, [this.cab.id_a]: valor };

      if (this.cab.clave_envio) {
        nuevosFiltros[this.cab.clave_envio] = valor;
      }

      return nuevosFiltros;
    });
  }

  handleRadio(valor) {
    this.setFiltrosAAplicar((prevState) => {
      const clave = this.cab.clave_envio;

      if (!valor) {
        const newState = { ...prevState, [this.cab.id_a]: null };
        if (clave) {
          newState[clave] = null;
        }
        return newState;
      }

      const newState = { ...prevState, [this.cab.id_a]: valor };
      if (clave) {
        newState[clave] = valor;
      }
      return newState;
    });

    this.setError((e) => {
      return { ...e, [this.cab.id_a]: false };
    });
  }

  handleSelect(valor) {
    // lógica para selects
    this.setFiltrosAAplicar((filtros) =>
      aplicarValorSelectAFiltros({
        filtros,
        id_a: this.cab.id_a,
        clave_envio: this.cab.clave_envio,
        valor,
      })
    );
  }

  handleToggle(valor) {
    // lógica para selects
    this.setFiltrosAAplicar((prev) => ({ ...prev, seleccion: valor }));
  }

  handleCheckbox(valor) {
    // lógica para selects
    this.setFiltrosAAplicar((prevState) => {
      if (!valor) {
        const newState = { ...prevState };
        delete newState[this.cab.id_a];
        return newState;
      }
      return {
        ...prevState,
        [this.cab.id_a]: "s",
      };
    });
  }

  handleDatePicker(valor, aux) {
    // lógica para fechas
    const { nuevasFechas } = aux;
    this.setFiltrosAAplicar((prevState) => {
      const clave = this.cab.clave_envio;
      const actualizar = (valor) => {
        const nuevosFiltros = { ...prevState, [this.cab.id_a]: valor };
        if (clave) {
          nuevosFiltros[clave] = valor;
        }
        return nuevosFiltros;
      };

      if (!valor?.toISOString().trim()) {
        return actualizar("");
      }

      // if (
      //   nuevasFechas.length !== 2 ||
      //   !nuevasFechas.every((el) => el !== undefined && el !== null)
      // ) {
      //   return prevState;
      // }
      
      return actualizar(JSON.stringify(nuevasFechas));
    });
    this.setError((e) => {
      return { ...e, [this.cab.id_a]: false };
    });
  }

  handleDatePickerFechaSimple(valor) {
    // lógica para fechas
    this.setFiltrosAAplicar((prevState) => {
      const clave = this.cab.clave_envio;
      const actualizar = (valor) => {
        const nuevosFiltros = { ...prevState, [this.cab.id_a]: valor };
        if (clave) {
          nuevosFiltros[clave] = valor;
        }
        return nuevosFiltros;
      };

      if (!valor?.toISOString().trim()) {
        return actualizar("");
      }

      return actualizar(valor?.toISOString());
    });
    this.setError((e) => {
      return { ...e, [this.cab.id_a]: false };
    });
  }
}
export default SetFiltros;
